(() => {
  function getVideoElement(parent) {
    let video;

    if (document.documentElement.clientWidth < 700) {
      video = parent.querySelector("video-media.sm\\:hidden video");
    } else {
      video = parent.querySelector("video-media.sm-max\\:hidden video");
    }

    if (!video) {
      return parent.querySelector("video");
    }

    return video;
  }

  function muteVideo(evt) {
    const parent = evt.target.closest(".shopify-section--video");

    const video = getVideoElement(parent);

    video.muted = true;

    parent.querySelector(".content-over-media__action--mute").style.display =
      "none";
    parent.querySelector(".content-over-media__action--unmute").style.display =
      "block";
  }

  function unmuteVideo(evt) {
    const parent = evt.target.closest(".shopify-section--video");

    const video = getVideoElement(parent);

    video.muted = false;
    parent.querySelector(".content-over-media__action--mute").style.display =
      "block";
    parent.querySelector(".content-over-media__action--unmute").style.display =
      "none";
  }

  function togglePause(evt) {
    const target = evt.target;

    if (!target.paused) {
      target.pause();
      target.setAttribute("paused", true);
    } else {
      target.play();
      target.removeAttribute("paused");
    }
  }

  document.querySelectorAll(".shopify-section--video video").forEach((item) => {
    const parent = item.closest(".shopify-section--video");

    if (parent.dataset.loaded === "true") {
      return;
    }

    parent.dataset.loaded = "true";

    item.addEventListener("click", togglePause, { passive: true });
    parent
      .querySelector(".content-over-media__action--mute")
      .addEventListener("click", muteVideo, { passive: true });
    parent
      .querySelector(".content-over-media__action--unmute")
      .addEventListener("click", unmuteVideo, { passive: true });
  });
})();
